// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"615b764f","256":"5ce4c788","296":"e31077c9","329":"7baea044","708":"37567aab","839":"0677de68","845":"3ad3c2c3"}[chunkId] + ".chunk.css";
};